const ITEMS = [
  "Anti-age",
  "Tecnologia postbiotica",
  "Made in Italy",
  "Pómalab Cosmetics",
  "Rituale in tre gesti",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-xl font-light uppercase tracking-[0.3em] text-gold-deep lg:text-2xl">
          {t}
        </span>
        <span className="h-2 w-2 rotate-45 bg-gold-grad" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="marquee-bar"
    className="relative overflow-hidden border-y border-gold/25 py-6"
    style={{ zIndex: 30, backgroundColor: "#FFFFFF" }}
  >
    <div className="marquee-track">
      <Row hidden={false} />
      <Row hidden={true} />
    </div>
  </div>
);
